import { useTranslation } from "react-i18next";

export function useDocumentsSteps() {
  const { t } = useTranslation("tours");
  return [
    {
      target: '[data-testid="documents-breadcrumb"]',
      title: t("documents.step1.title"),
      content: t("documents.step1.content"),
    },
    {
      target: '[data-testid="portfolio-guardian-block-primary-action"]',
      title: t("documents.step2.title"),
      content: t("documents.step2.content"),
    },
    {
      target: '[data-testid="documents-card"]',
      title: t("documents.step3.title"),
      content: t("documents.step3.content"),
    },
  ];
}
